/**
 * 想看图片组件 仿 antd 样式
 * Author: FJJ
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/05/23     1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 *
 *
 * */
import React from 'react';
import {Modal,   Spin} from 'antd';
import "./index.less";

class UploadImageComponent extends React.Component {
    static defaultProps = {
        accept:'*',
        flagLimitType:false,
        multiple:true,
        initValue:[],
        maxCount:1,
        styleUpload:'',

    };
    constructor(props) {
        super(props);
        this.state = {
            file: '',
            fileList:props.initValue,
            loading: false,
        };
    }
    init(successFn) {
    }
    /**
     * 预览
     * */
    handleCancel = () => this.setState({ previewVisible: false });
    handlePreview = fileName => {
        this.setState({
            previewImage:fileName,
            previewVisible: true,
        });
    };
    /**
     * render list
     * */
    renderList(list=[],accept='*'){
        let child = []
        list.forEach((item,inx)=>child.push(<div className={"ant-upload-list-picture-card-container"}>
                        <span>
                            <div className={"ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture-card"}>
                                <div className="ant-upload-list-item-info">
                                    <span><a
                                        className="ant-upload-list-item-thumbnail"
                                        target="_blank" rel="noopener noreferrer">
                                        <img
                                            src={item.fileUrl} className="ant-upload-list-item-image" />
                                        </a>
                                    </span>
                                </div>
                                <span className="ant-upload-list-item-actions">
                                    {item.fileUrl&&<span className={'action margin-left-5'} onClick={()=>this.handlePreview(item.fileUrl)}><i className="ri-eye-line color-white"> </i></span>}
                                </span>

                            </div>
                        </span>
        </div>))
        return child;
    }
    componentWillMount() {
    }
    componentDidMount() {
    }

    render() {
        const { fileList, previewVisible, previewImage, loading } = this.state;
        // console.log("fileList",fileList)
        return (<Spin spinning={loading}>
             <div className={"ant-upload-picture-card-wrapper"}>
                <div className={"ant-upload-list ant-upload-list-picture-card"}>
                    {fileList.length>0&&this.renderList(fileList)}
                </div>
            </div>
            {previewVisible&&<Modal open={previewVisible} width={900} footer={null} onCancel={this.handleCancel}>
                <img style={{ width: '100%' }} src={previewImage} />
            </Modal>}

            </Spin>);
    }
}
export default UploadImageComponent;